import React, { useContext, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../Common/ButtonComponent";
import {
  Button,
  Table,
  Row,
  Col,
  Input,
  DatePicker,
  Select,
  Space,
  Tooltip,
  Popover,
  Divider,
  Skeleton,
  Tag,
  Spin,
  Checkbox,
  TableColumnType,
  InputRef,
} from "antd";
import type { ColumnsType } from "antd/es/table";

import {
  PlusOutlined,
  SyncOutlined,
  EditOutlined,
  DownloadOutlined,
  DeleteTwoTone,
  ExceptionOutlined,
  SearchOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import noteContext from "../../Context/StyleContext";
import ViewSalesInvoice from "./ViewSalesInvoice";
import { Utils } from "../../../Utilities/Utils";
import { dayjs, tmpDayJs } from "../../../Utilities/dayjs";
import { useTheme } from "../../Context/ThemeContext";
import { useClient } from "../../Context/ClientContext";
import { BsCurrencyRupee } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/PageRoute";
import { HiDotsHorizontal } from "react-icons/hi";
import search from "../../Images/search.svg";
import ViewSalesInvoiceNoDetails from "./ViewSalesInvoiceNoDetails";
import downloadimg from "../../../images/downloadimg.svg";
import { useKeyboardShortcuts } from "../../Common/KeyboardShortcuts ";
import VoucherServices, {
  CashCreditFilter,
  CashCreditFilterOptions,
  Party_Tax,
  RCMFilter,
  RCMFilterOptions,
  VoucherFilterStatus,
  VoucherStatus_New,
  Voucher_Type,
} from "../../Services/VoucherServices";
import DownloadService, { ViewType } from "../../Services/DownloadService";
import { voucherType } from "../Reports/VoucherDetailsByLedger";
import ViewPreviewModel from "./ViewPreviewModel";
import EmailSendParty from "./EmailSendParty";
import { FiDownload } from "react-icons/fi";
// import { VoucherFilterStatus } from "../../Services/SalesService";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS, { ValueType } from "exceljs";
import InvoiceExportService from "../../Services/InvoiceExportDetails";
import { LocalChunkSize } from "papaparse";
import {
  FilterDropdownProps,
  TableRowSelection,
} from "antd/es/table/interface";
import DraftService from "../../Services/DraftService";
import AddJornalBadDebts from "../Journals/AddJornalBadDebts";
import SalesInvoicePDF from "./SalesInvoicePDF";
import PurchaseBillPDF from "./PurchaseBillPDF";
import {
  DateSearchTableEnum,
  DateSearchTableOption,
  NumberSearchTableEnum,
  NumberSearchTableOption,
  TableValueType,
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../Common/SearchTableOptions";
import { findUserPremission } from "../Users/UserSecurityFind";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import { SettingsSections } from "../../Services/SettingService";
import { useUser } from "../../../Context/UserContext";
import CbRangePicker from "../../Components/ui/Input/CbRangePicker";

export interface InvoiceDataType {
  key: React.Key;
  id: string;
  invNumber: {
    name: string;
    id: string;
  };
  customerName: {
    id: string;
    name: string;
    isDebitNature: boolean;
    partyOrTax: Party_Tax;
  };
  date: string;
  dueDate: string;
  invAmount: number;
  refundAmount: number;
  receivedAmount: number;
  dueBalance: number;
  status: string;
  voucherStatus: VoucherStatus_New;
  voucherType: Voucher_Type;
  voucherTitle: { id: number; name: string };
  //totalReceived: number;
  //totalUnpaid: number;
}

interface ISalesInvoiceProps {
  salesInvoiceList: any;
  setSalesInvoiceList: (value: any) => void;
  LoadSkeleton: boolean;
  setLoadSkeleton: (value: boolean) => void;
  partyId?: string;
  setLoading?: any;
}

const SalesInvoiceTable = (props: ISalesInvoiceProps) => {
  type DataIndex = keyof InvoiceDataType;
  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);

  const navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const themeData: any = useTheme();
  const location = useLocation();
  const { currentClient, companySettings } = useClient();
  const { clientSpecificRole } = useUser();
  const { windowWidth } = useContext(noteContext);
  const { openNotification } = useContext(notificationContext);
  const [page, setPage] = React.useState(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setIsOpen] = React.useState<string>("");
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>();
  const [invoiceId, setInvoiceId] = React.useState<string>("");
  const [partyId, setPartyId] = React.useState<string>("");
  const [type, setType] = React?.useState<any>();
  const [openPopArray, setOpenPopArray] = useState<boolean[]>([]);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [searchCustomer, setSearchCustomer] = React.useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [downLoadFile, setDownLoadFile] = React.useState<boolean>(false);
  const [refreshAtDelete, setRefreshAtDelete] = React.useState<boolean>(false);
  const [filterDate, setFilterDate] = React.useState<any>(
    JSON.parse(localStorage.getItem("LockPeriod")!)
      ? {
          from: JSON.parse(localStorage.getItem("LockPeriod")!).from,
          to: JSON.parse(localStorage.getItem("LockPeriod")!).to,
        }
      : {
          from: dayjs(companySettings?.period?.from).format("DD/MM/YYYY"),
          to: dayjs(companySettings?.period?.to).format("DD/MM/YYYY"),
        }
  );
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [invoiceStatus, setInvoiceStatus] = React.useState<number>(
    VoucherFilterStatus.Active
  );
  const [deleteOrRevive, setDeleteOrRevive] = React.useState<{
    id: string;
    isRev: boolean;
    number: string;
  }>({
    id: "",
    isRev: false,
    number: "",
  });
  const [deleteDraft, setDeleteDraft] = React.useState<{
    id: string;
    isConfirmation: boolean;
  }>({ id: "", isConfirmation: false });
  const [filter, setfilter] = React.useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [invoiceListData, setInvoiceListData] = React.useState<
    InvoiceDataType[]
  >([]);
  const [exportInvoiceData, setExportInvoiceData] = useState<InvoiceDataType[]>(
    []
  );
  const [emailLoading, setEmailLoading] = React.useState<boolean>(false);
  // const
  const [loadingButtons, setLoadingButtons] = useState<any>({});
  const [exportType, setExportType] = useState<number>(-1);
  const [rcmAndCashFilter, setRCMAndCashFilter] = useState<{
    rcm: RCMFilter;
    cashCredit: CashCreditFilter;
  }>({
    rcm: RCMFilter.Both,
    cashCredit: CashCreditFilter.All,
  });
  // const [apiCallExports, setApiCallExports] = useState<boolean>(false);

  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);
  const [searchColumns, setSearchColumns] = useState<any>({
    invNumber: "",
    customerName: "",
    date: null,
    // dateToRange: null,
    dueDate: null,
    // dueDateToRange: null,
    invAmount: "",
    refundAmount: "",
    receivedAmount: "",
    dueBalance: "",
  });
  const [searchDateRangeColumns, setSearchDateRangeColumns] = useState<any>({
    dateToRange: null,
    dueDateToRange: null,
  });

  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    numberDropEnum: TextSearchTableEnum;
    partyNameDropEnum: TextSearchTableEnum;
    invAmountDropEnum: NumberSearchTableEnum;
    refundAmountDropEnum: NumberSearchTableEnum;
    receivedAmountDropEnum: NumberSearchTableEnum;
    dueBalanceDropEnum: NumberSearchTableEnum;
    dateDropEnum: DateSearchTableEnum;
    dueDateDropEnum: DateSearchTableEnum;
  }>({
    numberDropEnum: TextSearchTableEnum.contains,
    partyNameDropEnum: TextSearchTableEnum.contains,
    invAmountDropEnum: NumberSearchTableEnum.equalTo,
    refundAmountDropEnum: NumberSearchTableEnum.equalTo,
    receivedAmountDropEnum: NumberSearchTableEnum.equalTo,
    dueBalanceDropEnum: NumberSearchTableEnum.equalTo,
    dateDropEnum: DateSearchTableEnum.equalTo,
    dueDateDropEnum: DateSearchTableEnum.equalTo,
  });
  const [showRange, setShowRange] = useState<{
    date: boolean;
    dueDate: boolean;
  }>({ date: false, dueDate: false });

  let splitPathInVchType: Voucher_Type;
  // let splitPathLedgerByGroupsType: SearchLedgerByGroupsTypes;
  if (location.pathname.split("/")[4] === "sales") {
    splitPathInVchType = Voucher_Type.SalesVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Sales;
  } else {
    splitPathInVchType = Voucher_Type.PurchaseVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Purchase;
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Get the selected row data
  const selectedRows = invoiceListData.filter((item) =>
    selectedRowKeys.includes(item.key)
  );

  console.log("Selected Row Keys:", selectedRowKeys);
  console.log("Selected Row Data:", selectedRows);

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    let prevValue = searchColumns[dataIndex];
    let newValue = selectedKeys;

    console.log("searchColumns", prevValue, selectedKeys);
    if (newValue?.length < 0) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    let newSearchColumns = { ...searchColumns };
    switch (dataIndex) {
      case "invNumber":
      case "customerName":
      case "invAmount":
      case "refundAmount":
      case "receivedAmount":
      case "dueBalance":
      case "date":
      case "dueDate":
        newSearchColumns[dataIndex] = selectedKeys[0];
        break;
      case "status":
        newSearchColumns[dataIndex] = selectedKeys;
        break;
    }

    if (!prevValue && newValue?.length > 0) {
      setSearchColumnCount((prev) => prev + 1);
    }

    setSearchColumns(newSearchColumns);
    console.log(
      searchColumnCount,
      "count",
      prevValue,
      newValue,
      selectedKeys,
      dataIndex
    );
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "customerName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          partyNameDropEnum: valDropDown,
        });
        break;
      case "invNumber":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          numberDropEnum: valDropDown,
        });
        break;
    }
  };

  const handleDropdownNumber = (
    dataIndex: DataIndex,
    valDropDown: NumberSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "invAmount":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          invAmountDropEnum: valDropDown,
        });
        break;
      case "refundAmount":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          refundAmountDropEnum: valDropDown,
        });
        break;
      case "receivedAmount":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          receivedAmountDropEnum: valDropDown,
        });
        break;
      case "dueBalance":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          dueBalanceDropEnum: valDropDown,
        });
        break;
    }
  };

  const handleDropdownDate = (
    dataIndex: DataIndex,
    valDropDown: DateSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "date":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          dateDropEnum: valDropDown,
        });
        if (valDropDown === DateSearchTableEnum.range) {
          setShowRange({ ...showRange, date: true });
        } else {
          setShowRange({ ...showRange, date: false });
        }

        break;
      case "dueDate":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          dueDateDropEnum: valDropDown,
        });
        if (valDropDown === DateSearchTableEnum.range) {
          setShowRange({ ...showRange, dueDate: true });
        } else {
          setShowRange({ ...showRange, dueDate: false });
        }
        break;
    }
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex];

    // console.log("newValue111", prevValue, dataIndex);

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);
    }
    if (prevValue) {
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    valueType?: TableValueType,
    searchPlaceHolder?: string
  ): TableColumnType<InvoiceDataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {dataIndex === "status" ? (
          <Checkbox.Group
            // options={companyGstAndNotGst?.map((gst: any) => ({
            //   key: gst.name,
            //   value: gst.id,
            //   title: gst.rate,
            //   label: gst.name,
            // }))}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            // value={searchColumns.gstRate}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : dataIndex === "date" || dataIndex === "dueDate" ? (
          <>
            <Select
              defaultValue={DateSearchTableEnum.equalTo}
              style={{
                width: "100%",
                maxWidth: "200px",
                marginBottom: "8px",
              }}
              onChange={(val: DateSearchTableEnum) => {
                setExportInvoiceData([]);
                handleDropdownDate(dataIndex, val);

                // setTextTypeSearchColumn(val);
                // setType(1);
              }}
              options={DateSearchTableOption?.map((x: any) => ({
                value: x.value,
                label: x.label,
                title: "",
              }))}
            />
            <DatePicker
              style={{
                width: "100%",
                maxWidth: "200px",
                marginBottom: "8px",
                display: "block",
              }}
              format="DD/MM/YYYY"
              placeholder={`Select.. ${searchPlaceHolder}`}
              allowClear={false}
              onChange={(value, dateString) => {
                setSelectedKeys(
                  value ? [value.endOf("day").toISOString()] : []
                );
                // console.log(
                //   "Selected Time: ",
                //   // value,
                //   // value.startOf("day"),
                //   // "",
                //   value.endOf("day").toISOString()
                // );
                // console.log("Formatted Selected Time: ", dateString);
              }}
            />
            {showRange.date && dataIndex === "date" && (
              <DatePicker
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                  display: "block",
                }}
                format="DD/MM/YYYY"
                placeholder={`Select.. To${searchPlaceHolder}`}
                disabled={!selectedKeys[0]}
                disabledDate={(current: any) =>
                  current &&
                  selectedKeys[0] &&
                  current.isSameOrBefore(
                    dayjs(selectedKeys[0] as string),
                    "day"
                  )
                }
                onChange={(value, dateString) => {
                  console.log("selectedKeys[0]", selectedKeys);
                  setSearchDateRangeColumns({
                    ...searchDateRangeColumns,
                    dateToRange: value
                      ? [value.endOf("day").toISOString()]
                      : [],
                  });
                  // setSelectedKeys(
                  //   value ? [value.endOf("day").toISOString()] : []
                  // );
                  console.log("Selected Time: ", selectedKeys[0]);
                  console.log("Formatted Selected Time: ", dateString);
                }}
              />
            )}
            {showRange.dueDate && dataIndex === "dueDate" && (
              <DatePicker
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                  display: "block",
                }}
                format="DD/MM/YYYY"
                placeholder={`Select.. To${searchPlaceHolder}`}
                onChange={(value, dateString) => {
                  setSearchDateRangeColumns({
                    ...searchDateRangeColumns,
                    dueDateToRange: value
                      ? [value.endOf("day").toISOString()]
                      : [],
                  });
                  // setSelectedKeys(
                  //   value ? [value.endOf("day").toISOString()] : []
                  // );
                  console.log("Selected Time: ", value, selectedKeys[0]);
                  console.log("Formatted Selected Time: ", dateString);
                }}
              />
            )}
          </>
        ) : (
          <>
            {valueType === TableValueType.Number ? (
              <Select
                defaultValue={NumberSearchTableEnum.equalTo}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: NumberSearchTableEnum) => {
                  setExportInvoiceData([]);
                  handleDropdownNumber(dataIndex, val);
                }}
                options={NumberSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                  title: "",
                }))}
              />
            ) : (
              <Select
                defaultValue={TextSearchTableEnum.contains}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: TextSearchTableEnum) => {
                  setExportInvoiceData([]);
                  handleDropdownText(dataIndex, val);
                }}
                options={TextSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                  title: "",
                }))}
              />
            )}
            <Input
              ref={searchInput}
              placeholder={`Search.. ${searchPlaceHolder}`}
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() =>
                handleSearch(selectedKeys as string[], confirm, dataIndex)
              }
              onKeyPress={(e: any) => {
                if (
                  dataIndex === "invAmount" ||
                  dataIndex === "dueBalance" ||
                  dataIndex === "refundAmount" ||
                  dataIndex === "receivedAmount"
                ) {
                  if (!/\d|[.,]/.test(e.key)) e.preventDefault();
                  // if (!/\d|\./.test(e.key)) e.preventDefault();
                  if (e.key === "." && e.target.value.includes("."))
                    e.preventDefault();
                }
              }}
              style={{ marginBottom: 8, display: "block", width: "200px" }}
            />
          </>
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}

            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      searchPlaceHolder ? (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "status") {
            searchSelect.current?.focus(); // Use focus for Select component
          } else {
            searchInput.current?.select(); // Use select for Input component
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  const permissionEdit =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? findUserPremission(
          ["Voucher.Sales.Invoice.Edit", "Voucher.Sales.id.Add"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.Invoice],
          {
            actionType: IPermissionActionType.View,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        )
      : findUserPremission(
          ["Voucher.Purchase.Bill.Edit"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.PurInvoice],
          {
            actionType: IPermissionActionType.Edit,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        );

  const permissionDelete =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? findUserPremission(
          ["Voucher.Sales.Invoice.Delete"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.Invoice],
          {
            actionType: IPermissionActionType.Delete,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        )
      : findUserPremission(
          ["Voucher.Purchase.Bill.Delete"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.PurInvoice],
          {
            actionType: IPermissionActionType.Delete,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        );

  const permissionAdd =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? findUserPremission(
          ["Voucher.Sales.Invoice.Add"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.Invoice],
          {
            actionType: IPermissionActionType.Add,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        )
      : findUserPremission(
          ["Voucher.Purchase.Bill.Add"],
          clientSpecificRole(),
          currentClient?.id!,
          [SettingsSections.PurInvoice],
          {
            actionType: IPermissionActionType.Add,
            dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
          }
        );

  // --------- Table Columns  ---------
  const columns: ColumnsType<InvoiceDataType> = [
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Invoice No."
          : "Bill No.",
      dataIndex: "invNumber",
      width: width <= 1440 ? "10%" : "9%",
      sorter: true,
      key: "Number",
      render: (_, record: InvoiceDataType) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherStatus !== 1 ? (
            <>
              <span
                style={{
                  color: themeData?.themeData?.themeColor,
                  cursor: "pointer",
                }}
                onClick={() => {
                  // downloadAndView(
                  //   currentClient?.id!,
                  //   record.invNumber?.id,
                  //   ViewType.Preview
                  // );
                  setIsOpen(
                    record?.voucherType === Voucher_Type.SalesVoucher
                      ? "viewPreview"
                      : "viewPurchaseBill"
                  );
                  setInvoiceId(record.invNumber?.id);
                  setPartyId(record.customerName?.id);
                  setType(record?.voucherType);
                  // setIsOpen("viewSalesInvoice");
                }}
              >
                {record?.invNumber?.name}
              </span>
            </>
          ) : (
            <>
              <span style={{ color: "red" }}>{record?.invNumber?.name}</span>
            </>
          )}
        </Skeleton>
      ),
      ...getColumnSearchProps("invNumber", TableValueType.Text, "Number"),
    },
    {
      title: "Party Name",
      key: "PLedger",
      sorter: true,
      dataIndex: "customerName",
      width: width <= 1440 ? "18%" : "25%",
      // ellipsis: true,
      render: (record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.partyOrTax === Party_Tax.party ? (
            <Link
              to={`/billing/clients/${currentClient?.id!}/party/partyLedger/${
                record?.id
              }`}

              // style={{ color: "#3a5dd3" }}
            >
              {record?.name}
            </Link>
          ) : record?.isBankLedger ? (
            <Link
              to={`/billing/clients/${currentClient?.id!}/banking/bankAccounts`}
              // style={{ color: "#3a5dd3" }}
              state={{
                bank: {
                  id: record?.id,
                  name: record?.name,
                  partyOrTax: record?.partyOrTax,
                },
              }}
            >
              {record?.name}
            </Link>
          ) : (
            <Link
              to={`/billing/clients/${currentClient?.id!}/banking/cashInHand`}
              // style={{ color: "#3a5dd3" }}
              state={{
                bank: {
                  id: record?.id,
                  name: record?.name,
                  partyOrTax: record?.partyOrTax,
                },
              }}
            >
              {record?.name}
            </Link>
          )}
        </Skeleton>
      ),
      ...getColumnSearchProps(
        "customerName",
        TableValueType.Text,
        "Party Name"
      ),
      // ...(splitPathInVchType === Voucher_Type.SalesVoucher
      //   ? getColumnSearchProps("customerName", false, "Party Name")
      //   : {}),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: true,
      // ellipsis: true,
      width: "100px",
      key: "Date",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.date}
        </Skeleton>
      ),
      // ...getColumnSearchProps("date", TableValueType.Date, "Date"),
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      sorter: true,
      // ellipsis: true,
      width: width <= 1440 ? "9%" : "8%",
      key: "DueDate",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {dayjs(record?.dueDate).format("DD/MM/YYYY")}
        </Skeleton>
      ),
      // ...getColumnSearchProps("dueDate", TableValueType.Date, "Due Date"),
    },
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Invoice Amount"
          : "Bill Amount",
      dataIndex: "invAmount",
      sorter: true,
      // align: "right",
      // ellipsis: true,
      width: "9%",
      key: "InvAmount",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{
            rows: 1,
            // style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {/* <Tooltip
            placement="topLeft"
            title={<>₹ {Utils.getFormattedNumber(record?.invAmount)}</>}
          > */}
          {/* </Tooltip> */}
          {record.voucherStatus !== 1 ? (
            <>₹ {Utils.getFormattedNumber(record?.invAmount)}</>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                ₹ {Utils.getFormattedNumber(record?.invAmount)}
              </span>
            </>
          )}
        </Skeleton>
      ),
      ...getColumnSearchProps(
        "invAmount",
        TableValueType.Number,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Invoice Amount"
          : "Bill Amount"
      ),
    },
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Credit Note"
          : "Debit Note",
      dataIndex: "refundAmount",
      // align: "right",
      sorter: true,
      key: "RefundAmount",
      width: "9%",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{
            rows: 1,
            // style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record.voucherStatus !== 1 ? (
            <> ₹ {Utils.getFormattedNumber(record?.refundAmount)}</>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                ₹ {Utils.getFormattedNumber(record?.refundAmount)}
              </span>
            </>
          )}
        </Skeleton>
      ),
      ...getColumnSearchProps(
        "refundAmount",
        TableValueType.Number,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Credit Note Amount"
          : "Debit Note Amount"
      ),
    },
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher ? "Received" : "Paid",
      dataIndex: "receivedAmount",
      sorter: true,
      // align: "right",
      key: "ReceivedAmount",
      // ellipsis: {
      //   showTitle: false,
      // },
      width: "9%",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{
            rows: 1,
            // style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {/* <Tooltip
            placement="topLeft"
            title={
              record?.bank === 0 ? (
                <span>
                  ₹{Utils.getFormattedNumber(record?.paid - record?.bank)}
                </span>
              ) : (
                <>
                  <span>paid: ₹{Utils.getFormattedNumber(record?.paid)}</span>
                  <br />
                  <span>bank: ₹{Utils.getFormattedNumber(record?.bank)}</span>
                </>
              )
            }
          > */}

          {record.voucherStatus !== 1 ? (
            <>
              <span onClick={() => console.log(record?.bank)}>
                ₹ {Utils.getFormattedNumber(record?.receivedAmount)}
              </span>
            </>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                ₹ {Utils.getFormattedNumber(record?.receivedAmount)}
              </span>
            </>
          )}
          {/* </Tooltip> */}
        </Skeleton>
      ),
      ...getColumnSearchProps(
        "receivedAmount",
        TableValueType.Number,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Received Amount"
          : "Paid Amount"
      ),
    },
    {
      title: "Due Amount",
      dataIndex: "dueBalance",
      sorter: true,
      // align: "right",
      key: "PendingAmount",
      // ellipsis: {
      //   showTitle: false,
      // },
      width: "9%",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{
            rows: 1,
            // style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {/* <Tooltip
            placement="topLeft"
            title={
              <span>₹ {Utils.getFormattedNumber(record?.dueBalance)}</span>
            }
          > */}

          {record.voucherStatus !== 1 ? (
            <>
              {record?.tdsAmt > 0 ? (
                <Tooltip title={`TDS Amount ${record?.tdsAmt} deducted.`}>
                  <span>
                    ₹ {Utils.getFormattedNumber(record?.dueBalance)}{" "}
                    <ExceptionOutlined color="#3e5746" />
                  </span>
                </Tooltip>
              ) : (
                <span>₹ {Utils.getFormattedNumber(record?.dueBalance)}</span>
              )}
            </>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                <span>₹ {Utils.getFormattedNumber(record?.dueBalance)}</span>
              </span>
            </>
          )}
          {/* </Tooltip> */}
        </Skeleton>
      ),
      ...getColumnSearchProps(
        "dueBalance",
        TableValueType.Number,
        "Due Amount"
      ),
    },
    {
      title: "Status",
      dataIndex: "payStatus",
      key: "Status",
      width: "7%",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherStatus !== 1 ? (
            <>
              <span
                style={{
                  border: "1px solid #E4E8F0",
                  fontWeight: 500,
                  display: "block",
                  textAlign: "center",
                  fontSize: "13px",
                  borderRadius: 4,

                  color:
                    record.status === "Due"
                      ? "#FAAD14"
                      : record.status === "Overdue"
                      ? "#FF4D4F"
                      : record.status === "Paid"
                      ? "#52C41A"
                      : "geekblue",
                  backgroundColor: "white",
                }}
              >
                {splitPathInVchType === Voucher_Type.SalesVoucher &&
                record?.status === "Paid"
                  ? "Received"
                  : record?.status}
              </span>
            </>
          ) : (
            <>
              <Tag color="red">Deleted</Tag>
            </>
          )}
          {/* <InvoiceStatusShow
            dueDate={record?.dueDate}
            due={record?.dueBalance}
            refund={record?.refundAmount}
            invAmount={record?.invAmount}
          /> */}{" "}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "icon",
      width: "10%",
      align: "center",
      render: (_, record, index) => (
        <Skeleton
          className="cursor"
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {/* <div style={{ display: "flex", justifyContent: "space-around" }}> */}
          <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
            {/* <FiDownload
              onClick={() => CreatePdf(record)}
              style={{ color: "#395cd2" }}
              /> 
              */}
            {/* {invoiceStatus === VoucherFilterStatus.Deleted || invoiceStatus ===
            VoucherFilterStatus.All */}

            {/* {record?.voucherStatus !== 1 && (
              <>
                <Button
                  size="small"
                  icon={<FiDownload />}
                  style={{ border: "none", color: "#395cd2" }}
                  loading={!!loadingButtons[record.invNumber?.id]}
                  onClick={() =>
                    downloadAndView(
                      currentClient?.id!,
                      record.invNumber?.id,
                      ViewType.Pdf
                      // record.invNumber?.id
                    )
                  }
                />
              </>
            )} */}
            {record.voucherStatus === VoucherStatus_New.Active &&
            findUserPremission(
              [
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? "Voucher.Sales.Invoice.Edit"
                  : "Voucher.Purchase.Bill.Edit",
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? `Voucher.Sales.${record?.voucherTitle?.id}.Edit`
                  : `Voucher.Purchase.${record?.voucherTitle?.id}.Edit`,
              ],
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <Tooltip title="Edit" placement="top">
                <EditOutlined
                  onClick={() => {
                    splitPathInVchType === Voucher_Type.SalesVoucher
                      ? navigate(
                          `/billing/clients/${currentClient?.id}/sales/editInvoice/${record?.invNumber?.id}`,
                          {
                            state: { copy: false },
                          }
                        )
                      : navigate(
                          `/billing/clients/${currentClient?.id}/purchase/editPurchaseBill/${record?.invNumber?.id}`,
                          {
                            state: { copy: false },
                          }
                        );
                  }}
                />
              </Tooltip>
            ) : (
              findUserPremission(
                [
                  splitPathInVchType === Voucher_Type.SalesVoucher
                    ? "Voucher.Sales.Invoice.Add"
                    : "Voucher.Purchase.Bill.Add",
                  splitPathInVchType === Voucher_Type.SalesVoucher
                    ? `Voucher.Sales.${record?.voucherTitle?.id}.Add`
                    : `Voucher.Purchase.${record?.voucherTitle?.id}.Add`,
                ],
                clientSpecificRole(),
                currentClient?.id!
              ) && (
                <Tooltip title="Reviev Voucher">
                  <SyncOutlined
                    style={{ color: "green" }}
                    // className="ca-delete-btn cursor"
                    onClick={() => {
                      splitPathInVchType === Voucher_Type.SalesVoucher
                        ? navigate(
                            `/billing/clients/${currentClient?.id}/sales/editInvoice/${record?.invNumber?.id}`,
                            {
                              state: { copy: false },
                            }
                          )
                        : navigate(
                            `/billing/clients/${currentClient?.id}/purchase/editPurchaseBill/${record?.invNumber?.id}`,
                            {
                              state: { copy: false },
                            }
                          );
                    }}
                  />
                </Tooltip>
              )
            )}

            {record?.voucherStatus !== 1 && (
              <>
                <Popover
                  arrow={{ pointAtCenter: true }}
                  placement="bottomRight"
                  content={ellipsisContent(record, index, record.voucherStatus)}
                  trigger="click"
                  open={openPopArray[index]}
                  onOpenChange={(newOpen) =>
                    handlePopoverChange(index, newOpen)
                  }
                >
                  <HiDotsHorizontal
                    style={{
                      color: "#395cd2",
                      cursor: "pointer",
                      marginTop: "5px",
                    }}
                  />
                </Popover>
              </>
            )}
          </div>
        </Skeleton>
      ),
    },
  ];

  //  Draft Colums
  const draftColumns: ColumnsType<InvoiceDataType> = [
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Invoice No."
          : "Bill No.",
      dataIndex: "invNumber",

      width: "10%",
      sorter: true,
      key: "Number",
      render: (_, record: InvoiceDataType) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherStatus !== 1 ? (
            <>
              <span
                style={{
                  color: themeData?.themeData?.themeColor, ///TODO: need to handle
                  cursor: "pointer",
                }}
                onClick={() => {
                  // downloadAndView(
                  //   currentClient?.id!,
                  //   record.invNumber?.id,
                  //   ViewType.Preview
                  // );
                  setIsOpen(
                    record?.voucherType === Voucher_Type.SalesVoucher
                      ? "viewPreview"
                      : "viewPurchaseBill"
                  );

                  setInvoiceId(record.invNumber?.id);
                  setPartyId(record.customerName?.id);
                  setType(record?.voucherType);
                  // setIsOpen("viewSalesInvoice");
                }}
              >
                {record?.invNumber?.name}
              </span>
            </>
          ) : (
            <>
              <span style={{ color: "red" }}>{record?.invNumber?.name}</span>
            </>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Party Name",
      key: "pLedger",
      sorter: true,
      dataIndex: "customerName",
      width: "30%",
      // ellipsis: true,
      render: (record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.partyOrTax === Party_Tax.party ? (
            <Link
              to={`/billing/clients/${currentClient?.id!}/party/partyLedger/${
                record?.id
              }`}

              // style={{ color: "#3a5dd3" }}
            >
              {record?.name}
            </Link>
          ) : record?.isBankLedger ? (
            <Link
              to={`/billing/clients/${currentClient?.id!}/banking/bankAccounts`}
              // style={{ color: "#3a5dd3" }}
              state={{
                bank: {
                  id: record?.id,
                  name: record?.name,
                  partyOrTax: record?.partyOrTax,
                },
              }}
            >
              {record?.name}
            </Link>
          ) : (
            <Link
              to={`/billing/clients/${currentClient?.id!}/banking/cashInHand`}
              // style={{ color: "#3a5dd3" }}
              state={{
                bank: {
                  id: record?.id,
                  name: record?.name,
                  partyOrTax: record?.partyOrTax,
                },
              }}
            >
              {record?.name}
            </Link>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: true,
      // ellipsis: true,
      width: "15%",
      key: "Date",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.date}
        </Skeleton>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      sorter: true,
      // ellipsis: true,
      width: "15%",
      key: "DueDate",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {dayjs(record?.dueDate).format("DD/MM/YYYY")}
        </Skeleton>
      ),
    },
    {
      title:
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Invoice Amount"
          : "Bill Amount",
      dataIndex: "invAmount",
      sorter: true,
      align: "right",
      // ellipsis: true,
      width: "15%",
      key: "InvAmount",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={props?.LoadSkeleton}
          paragraph={{
            rows: 1,
            // style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {/* <Tooltip
            placement="topLeft"
            title={<>₹ {Utils.getFormattedNumber(record?.invAmount)}</>}
          > */}
          {/* </Tooltip> */}
          {record.voucherStatus !== 1 ? (
            <>₹ {Utils.getFormattedNumber(record?.invAmount)}</>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                ₹ {Utils.getFormattedNumber(record?.invAmount)}
              </span>
            </>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "icon",
      width: "10%",
      align: "center",
      render: (_, record, index) => (
        <Skeleton
          className="cursor"
          active
          loading={props?.LoadSkeleton}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {/* <div style={{ display: "flex", justifyContent: "space-around" }}> */}
          <div
            style={{ display: "flex", justifyContent: "space-around", gap: 1 }}
          >
            {/* <FiDownload
              onClick={() => CreatePdf(record)}
              style={{ color: "#395cd2" }}
              /> 
              */}
            {/* 
            {invoiceStatus === VoucherFilterStatus.Deleted || invoiceStatus ===
            VoucherFilterStatus.All 
            */}

            <Tooltip title="Edit" placement="top">
              <EditOutlined
                onClick={() => {
                  splitPathInVchType === Voucher_Type.SalesVoucher
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editInvoiceDraft/${record?.invNumber?.id}`,
                        {
                          state: { copy: false },
                        }
                      )
                    : navigate(
                        `/billing/clients/${currentClient?.id}/purchase/editBillDraft/${record?.invNumber?.id}`,
                        {
                          state: { copy: false },
                        }
                      );
                }}
              />
            </Tooltip>

            <Tooltip title="Delete Permanently" placement="top" color="red">
              <DeleteTwoTone
                className="ca-delete-btn"
                twoToneColor="#ff879d"
                onClick={() => {
                  console.log("Hello", record);

                  setDeleteDraft({
                    id: record?.invNumber?.id,
                    isConfirmation: true,
                  });
                  // setConfirmationModel(true);
                  // setEstimateId(record?.id);
                  // setDeleteEstimate({
                  //   ...deleteEstimate,
                  //   status: DBRecordStatus.Deleted,
                  //   name: record?.number,
                  // });
                }}
              />
            </Tooltip>
          </div>
        </Skeleton>
      ),
    },
  ];

  // condition for delete and revive
  // if (
  //   invoiceStatus === VoucherFilterStatus.Deleted ||
  //   invoiceStatus === VoucherFilterStatus.All
  // ) {
  //   columns.push({
  //     width: "10%",
  //     align: "left",
  // render: (_, record) => (
  //   <Skeleton
  //     className="cursor"
  //     active
  //     loading={props?.LoadSkeleton}
  //     paragraph={{ rows: 1 }}
  //     title={false}
  //   >
  //     <Tooltip title="Revive invoice and its effects on calculations">
  //       <SyncOutlined
  //         onClick={() => {
  //           setConfirmation(true);
  //           setInvoiceId(record?.invNumber?.id);
  //         }}
  //       />
  //     </Tooltip>
  //   </Skeleton>
  // ),
  // });
  // }

  if (false) {
    columns.push(
      {
        title: "  ",
        dataIndex: "icon",
        width: "3%",
        align: "center",
        render: (_, record) => (
          <Skeleton
            className="cursor"
            active
            loading={props?.LoadSkeleton}
            paragraph={{ rows: 1 }}
            title={false}
          >
            {/* <FiDownload
              onClick={() => CreatePdf(record)}
              style={{ color: "#395cd2" }}
            /> */}
            <img
              alt="download"
              style={{ cursor: "pointer" }}
              src={downloadimg}
            />
          </Skeleton>
        ),
      },
      {
        title: "  ",
        dataIndex: "icon2",
        width: "3%",
        align: "center",
        render: (_, record) => (
          <Skeleton
            active
            loading={props?.LoadSkeleton}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Tooltip title="Edit" placement="top">
              <EditOutlined
                onClick={() => {
                  splitPathInVchType === Voucher_Type.SalesVoucher
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/editInvoice/${record?.invNumber?.id}`,
                        {
                          state: { copy: false },
                        }
                      )
                    : navigate(
                        `/billing/clients/${currentClient?.id}/purchase/editPurchaseBill/${record?.invNumber?.id}`,
                        {
                          state: { copy: false },
                        }
                      );
                }}
              />
            </Tooltip>
          </Skeleton>
        ),
      },
      // {
      //   title: "  ",
      //   dataIndex: "icon2",
      //   width: "3%",
      //   align: "center",
      //   render: (_, record) => (
      //     <Skeleton
      //       active
      //       loading={props?.LoadSkeleton}
      //       paragraph={{ rows: 1 }}
      //       title={false}
      //     >
      //       <Tooltip
      //         title={
      //           record?.receivedAmount?.paid === 0 && record?.refundAmount === 0
      //             ? "Edit"
      //             : "Invoice is either paid or refunded"
      //         }
      //         placement="top"
      //         color={
      //           record?.receivedAmount?.paid === 0 && record?.refundAmount === 0
      //             ? "#3D4998"
      //             : "gray"
      //         }
      //       >
      //         <EditOutlined
      //           style={{
      //             color:
      //               record?.receivedAmount?.paid === 0 &&
      //               record?.refundAmount === 0
      //                 ? "#444653"
      //                 : "rgb(216 207 207)",
      //           }}
      //           className={
      //             record?.receivedAmount?.paid === 0 &&
      //             record?.refundAmount === 0
      //               ? "ca-edit-btn"
      //               : ""
      //           }
      //           onClick={() => {
      //             if (
      //               record?.receivedAmount?.paid === 0 &&
      //               record?.refundAmount === 0
      //             )
      //               navigate(
      //                 `/accounts/clients/${currentClient?.id}/sales/editInvoice/${record?.id}`,
      //                 {
      //                   state: { copy: false },
      //                 }
      //               );
      //           }}
      //         />
      //       </Tooltip>
      //     </Skeleton>
      //   ),
      // },
      // {
      //   title: "  ",
      //   dataIndex: "icon3",
      //   width: "2%",
      //   align: "center",
      //   render: (_, record) => (
      //     <Skeleton
      //       active
      //       loading={props?.LoadSkeleton}
      //       paragraph={{ rows: 1 }}
      //       title={false}
      //     >
      //       <div
      //         className={record?.dueBalance === 0 ? "" : "cursor"}
      //         style={{
      //           // backgroundColor:
      //           //   record?.dueBalance === 0 ? "rgba(239, 239, 239, 0.6)" : "",
      //           textAlign: "center",
      //         }}
      //       >
      //         <Tooltip
      //           title={
      //             record?.dueBalance === 0
      //               ? "Invoice is either paid or refunded"
      //               : "Create Receipt"
      //           }
      //           placement="top"
      //           color={record?.dueBalance === 0 ? "gray" : ""}
      //         >
      //           <BsCurrencyRupee
      //             color={
      //               record?.dueBalance === 0 ? "rgb(216 207 207)" : "#868ea5"
      //             }
      //             onClick={() => {
      //               if (record?.dueBalance !== 0) {
      //                 navigate(
      //                   `/accounts/clients/${currentClient?.id}/sales/addPaymentIn`,
      //                   {
      //                     state: {
      //                       invoiceId: record?.invNumber?.id,
      //                       values: {
      //                         value: record?.dueBalance,
      //                       },
      //                     },
      //                   }
      //                 );
      //               }
      //             }}
      //           />
      //         </Tooltip>
      //       </div>
      //     </Skeleton>
      //   ),
      // },
      {
        title: "  ",
        width: "2%",
        align: "center",
        render: (_, record, index) => (
          <Skeleton
            active
            loading={props?.LoadSkeleton}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Popover
              arrow={{ pointAtCenter: true }}
              placement="bottomRight"
              content={ellipsisContent(record, index, record.voucherStatus)}
              trigger="click"
              open={openPopArray[index]}
              onOpenChange={(newOpen) => handlePopoverChange(index, newOpen)}
            >
              <HiDotsHorizontal
                style={{ color: "#395cd2", cursor: "pointer" }}
              />
            </Popover>
          </Skeleton>
        ),
      }
      // {
      //   title: " total ",
      //   width: "15%",
      //   align: "center",
      //   fixed: "right",
      // }
    );
  }

  const handlePopoverChange = (columnIndex: number, newOpen: boolean) => {
    const updatedOpenPopArray = [...openPopArray];
    updatedOpenPopArray[columnIndex] = newOpen;
    setOpenPopArray(updatedOpenPopArray);
  };

  const ellipsisContent = (
    record: InvoiceDataType,
    index: number,
    status: VoucherStatus_New
  ) => {
    return (
      <div>
        {status === VoucherStatus_New.Active && (
          <>
            {findUserPremission(
              [
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? "Voucher.Sales.Invoice.Add"
                  : "Voucher.Purchase.Bill.Add",
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? `Voucher.Sales.${record?.voucherTitle?.id}.Add`
                  : `Voucher.Purchase.${record?.voucherTitle?.id}.Add`,
              ],
              clientSpecificRole(),
              currentClient?.id!
            ) && (
              <>
                <Button
                  style={{ width: 100 }}
                  onClick={() => {
                    splitPathInVchType === Voucher_Type.SalesVoucher
                      ? navigate(
                          `/billing/clients/${currentClient?.id}/sales/cloneInvoice/${record.id}`
                        )
                      : navigate(
                          `/billing/clients/${currentClient?.id}/purchase/cloneBill/${record.id}`
                        );
                  }}
                >
                  Clone
                </Button>
                <Divider className="my-5" />
              </>
            )}

            {findUserPremission(
              [
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? "Voucher.Sales.Invoice.Delete"
                  : "Voucher.Purchase.Bill.Delete",
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? `Voucher.Sales.${record?.voucherTitle?.id}.Delete`
                  : `Voucher.Purchase.${record?.voucherTitle?.id}.Delete`,
              ],
              clientSpecificRole(),
              currentClient?.id!
            ) && (
              <>
                <Tooltip
                  title={
                    // record?.receivedAmount?.paid > 0 || record?.refundAmount > 0
                    // ? "This record can't be deleted because it has an associated transaction."
                    "Delete temporarily"
                  }
                >
                  <Button
                    disabled={
                      // record?.receivedAmount?.paid > 0 || record?.refundAmount > 0
                      // ? true
                      // : false
                      false
                    }
                    style={{ width: 100 }}
                    onClick={() => {
                      setConfirmation(true);
                      setInvoiceId(record?.id);
                      setDeleteOrRevive({
                        ...deleteOrRevive,
                        number: record.invNumber.name,
                      });
                      handlePopoverChange(index, false);
                    }}
                  >
                    Delete
                  </Button>
                </Tooltip>
                <Divider className="my-5" />
              </>
            )}

            {findUserPremission(
              [
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? "Voucher.Sales.CreditNote.Add"
                  : "Voucher.Purchase.DebitNote.Add",
              ],
              clientSpecificRole(),
              currentClient?.id!,
              [
                splitPathInVchType === Voucher_Type.SalesVoucher
                  ? SettingsSections.CrNote
                  : SettingsSections.DrNote,
              ],
              {
                actionType: IPermissionActionType.Add,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) && (
              <>
                <Tooltip
                  title={
                    record?.invAmount === record?.refundAmount
                      ? `This record can't be create ${
                          splitPathInVchType === Voucher_Type.SalesVoucher
                            ? "credit"
                            : "debit"
                        } note because it invoice all refund`
                      : //  record?.invAmount === record?.receivedAmount
                        // ? `This record can't be create  ${
                        //     splitPathInVchType === Voucher_Type.SalesVoucher
                        //       ? "credit"
                        //       : "debit"
                        //   } note because it invoice all Paid`
                        // :
                        ""
                  }
                >
                  <Button
                    style={{ width: 100 }}
                    disabled={
                      record?.invAmount === record?.refundAmount
                        ? // || record?.invAmount === record?.receivedAmount
                          true
                        : false
                    }
                    onClick={() => {
                      splitPathInVchType === Voucher_Type.SalesVoucher
                        ? navigate(
                            `/billing/clients/${currentClient?.id}/sales/addCreditNote`,
                            {
                              state: {
                                invoice: record.invNumber,
                                partyId: record?.customerName.id,
                              },
                            }
                          )
                        : navigate(
                            `/billing/clients/${currentClient?.id}/purchase/addDebitNote`,
                            {
                              state: {
                                invoice: record.invNumber,
                                partyId: record?.customerName.id,
                              },
                            }
                          );
                    }}
                  >
                    {splitPathInVchType === Voucher_Type.SalesVoucher
                      ? "Credit Note"
                      : "Debit Note"}
                  </Button>
                </Tooltip>
                <Divider className="my-5" />
              </>
            )}

            {/* <Divider className="my-5" />
            <Tooltip
            // title={
            //   "Delete temporarily"
            // }
            >
              <Button
                disabled={
                  record?.invAmount === record?.refundAmount ||
                  record?.invAmount === record?.receivedAmount
                    ? true
                    : false
                }
                style={{ width: 100 }}
                onClick={() => {
                  setInvoiceId(record?.id);
                  setIsOpen("addJornalBadDebts");
                  handlePopoverChange(index, false);
                }}
              >
                Bad Debts
              </Button>
            </Tooltip> */}
          </>
        )}

        <Button
          style={{ width: 100 }}
          loading={emailLoading}
          onClick={() => {
            setEmailLoading(openPopArray[index] ? true : false);
            sendEmail(
              currentClient?.id!,
              record.invNumber?.id,
              ViewType.Pdf,
              record.customerName?.id
            );
          }}
        >
          Email Pdf
        </Button>
        <Divider className="my-5" />

        <Button
          style={{ width: 100 }}
          onClick={() => {
            handlePopoverChange(index, false);
            setPartyId(record.customerName?.id);
            setInvoiceId(record.id);
            setIsOpen("emailSendParty");
          }}
        >
          Email
        </Button>

        {/* <Divider className="my-5" /> */}
        {/* <Button
          style={{ width: 100 }}
          onClick={() => {
            setIsOpen("viewInvoiceNoAllDetails");
            setInvoiceId(record.id);
            handlePopoverChange(index, false);
          }}
        >
          All Details
        </Button> */}
      </div>
    );
  };

  React.useEffect(() => {
    // console.log(width);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  // ----- Delete or revive invoices api -----
  React.useEffect(() => {
    if (deleteOrRevive.id) {
      const DeleteOrRevive = async () => {
        setLoading(true);
        try {
          const res = await VoucherServices.deleteVoucher(
            currentClient?.id!,
            deleteOrRevive.id
          );
          if (res.result) {
            setRefreshAtDelete(!refreshAtDelete);
            setExportType(-1);
            setExportInvoiceData([]);
            openNotification(
              "success",
              `Voucher ${deleteOrRevive.number} ${
                invoiceStatus === VoucherFilterStatus.Deleted
                  ? `revived`
                  : `deleted`
              } successfully.`
            );
            setConfirmation(false);
          } else {
            openNotification("error", res.message);
            setLoading(false);
            setConfirmation(false);
          }
        } catch (err: any) {
          console.error("error..", err);
          openNotification("error", err.message);
          setConfirmation(false);
        }
        setDeleteOrRevive({ id: "", isRev: false, number: "" });
      };
      DeleteOrRevive();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteOrRevive?.id]);

  console.log(
    "Date Test: ",
    dayjs(filterDate.from, "DD/MM/YYYY").toISOString()
  );

  // --------- Get TableData API ---------
  React.useEffect(() => {
    if (currentClient?.id && (exportType === -1 || exportType)) {
      const requestModel = {
        number: searchColumns.invNumber,
        numberDropEnum: searchColumnsDropDown.numberDropEnum,

        partyName: searchColumns.customerName,
        partyNameDropEnum: searchColumnsDropDown.partyNameDropEnum,

        invAmount: Utils.getIsNaNReturnNull(searchColumns.invAmount),
        invAmountDropEnum: searchColumnsDropDown.invAmountDropEnum,

        refundAmount: Utils.getIsNaNReturnNull(searchColumns.refundAmount),
        refundAmountDropEnum: searchColumnsDropDown.refundAmountDropEnum,

        receivedAmount: Utils.getIsNaNReturnNull(searchColumns.receivedAmount),
        receivedAmountDropEnum: searchColumnsDropDown.receivedAmountDropEnum,

        pendingAmount: Utils.getIsNaNReturnNull(searchColumns.dueBalance),
        pendingAmountDropEnum: searchColumnsDropDown.dueBalanceDropEnum,

        // date: dayjs(searchColumns.date, "DD/MM/YYYY")
        //   .endOf("day")
        //   .toISOString(),
        // dateDropEnum: searchColumnsDropDown.dateDropEnum,
        // dateToRange: dayjs(searchColumns.dateToRange, "DD/MM/YYYY")
        //   .endOf("day")
        //   .toISOString(),

        // dueDate: dayjs(searchColumns.dueDate, "DD/MM/YYYY")
        //   .endOf("day")
        //   .toISOString(),
        // dueDateDropEnum: searchColumnsDropDown.dueDateDropEnum,
        // dueDateToRange: dayjs(searchColumns.dueDateToRange, "DD/MM/YYYY")
        //   .endOf("day")
        //   .toISOString(),
      };
      getList(
        currentClient?.id,
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? Voucher_Type.SalesVoucher
          : Voucher_Type.PurchaseVoucher,
        // apiCallExports && exportType ? 0 : (page - 1) * pageSize,
        // apiCallExports && exportType ? 0 : pageSize,
        dayjs(filterDate.from, "DD/MM/YYYY").toISOString(),
        dayjs(filterDate.to, "DD/MM/YYYY").endOf("day").toISOString(),
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        filter.sortCol,
        filter.sortDir,
        undefined,
        undefined,
        searchCustomer,
        invoiceStatus,
        rcmAndCashFilter.rcm,
        rcmAndCashFilter.cashCredit,
        requestModel
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    page,
    pageSize,
    filter.sortCol,
    filter.sortDir,
    filterDate.from,
    filterDate.to,
    searchCustomer,
    refreshAtDelete,
    invoiceStatus,
    // apiCallExports,
    exportType,
    rcmAndCashFilter,
    searchColumns,
  ]);

  // ----- Table Ascending & Desending Order -----
  const getList = async (
    clientId: string,
    Voucher_Type: Voucher_Type,
    fromDate: string,
    toDate: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    noPartyId?: string,
    npReconciled?: string,
    search?: string,
    invoiceStatus?: VoucherFilterStatus,
    rCMFilter?: RCMFilter,
    cashCreditFilter?: CashCreditFilter,
    requestModel?: any
  ) => {
    try {
      if (exportType < 1) {
        setLoading(true);
        props.setLoadSkeleton(true);
        props?.setLoading(true);
      }

      const res =
        invoiceStatus === VoucherFilterStatus.Draft
          ? await DraftService.getVoucherDraftList(
              clientId,
              Voucher_Type,
              fromDate,
              toDate,
              start,
              length,
              sortCol,
              sortDir,
              noPartyId,
              search
            )
          : await VoucherServices.getVoucharList(
              clientId,
              Voucher_Type,
              fromDate,
              toDate,
              start,
              length,
              sortCol,
              sortDir,
              noPartyId,
              npReconciled,
              search,
              invoiceStatus,
              undefined, // itemId
              rCMFilter,
              cashCreditFilter,
              requestModel
            );

      if (res?.result?.voucherItems?.length > 0) {
        props.setLoadSkeleton(false);
        // setTotAmount(res?.result?.totalAmount);
        let invoiceData: InvoiceDataType[] = res?.result?.voucherItems?.map(
          (v: any, index: number) => {
            // console.log("This is my data", v);
            return {
              key: index,
              id: v?.vId,
              date: dayjs(v?.date).format("DD/MM/YYYY"),
              dueDate: v?.dueDate,
              invNumber: { name: v?.number, id: v?.vId },
              customerName: {
                id: v?.pLedger[0].id,
                name: v?.pLedger[0]?.ledgerName,
                isDebitNature: v?.pLedger[0]?.ledgerName,
                partyOrTax: v?.pLedger[0]?.partyOrTax,
                isBankLedger: v?.pLedger[0]?.isBankLedger,
              },
              invAmount: v?.invAmount,
              refundAmount: v?.refundAmount,
              receivedAmount: v?.receivedAmount,
              tdsAmt: v?.amountSummary?.tdsAmt,
              status: v?.status,
              voucherStatus: v?.voucherStatus,
              voucherType: v?.voucherType,
              // receivedAmount: {
              // paid: v?.amount?.paid,
              // bank: v?.amount?.bankAmount,
              // },
              dueBalance: v?.pendingAmount,
              voucherTitle: v?.voucherTitle,
              //dueBalance: v?.dueAmount,
            };
          }
        );
        if (exportType >= 1) {
          setExportInvoiceData(invoiceData);
          if (exportType === 1) {
            exportCsv(invoiceData);
          } else if (exportType === 2) {
            exportPDF(invoiceData);
          } else if (exportType === 3) {
            exportExcel(invoiceData);
          }
        } else {
          setInvoiceListData(invoiceData);
          props.setSalesInvoiceList({
            //// Previous declarations :
            //totalReceived: res?.total?.recieved,
            //totalUnpaid: res?.total?.unpaid,
            //totalReceived: res?.result?.totalReceivedAmount,
            //totalUnpaid: res?.result?.totalDueAmount,
            //totalOverdue: res?.result?.totalOverDueAmount,
            //totalRefund: res?.total?.refund,
            //totalRefund: res?.result?.totalRefundAmount,
            // totalSalesAmount:
            //   res?.result?.totalAmount - res?.result?.totalRefundAmount,
            // totalRefundAmount: res?.total?.pageItemTotal?.tRefund,
            // totalReceivedAmount: res?.total?.pageItemTotal?.tReceived,
            // totalDueAmount: res?.total?.pageItemTotal?.tDueAmt,

            //total According to per page------
            totalInvoiceAmount: res?.result?.totalAmount,
            totalRefundAmount: res?.result?.totalRefundAmount,
            totalReceivedAmount: res?.result?.totalReceivedAmount,
            totalDueAmount: res?.result?.totalPendingAmount,

            //total According to all records------
            overallSalesAmount:
              res?.result.overallOverDueAmount +
              res?.result.overallDueAmount +
              res?.result.overallReceivedAmount,
            overallOverDueAmount: res?.result.overallOverDueAmount,
            OverallDueAmount: res?.result.overallDueAmount,
            overallReceivedAmount: res?.result.overallReceivedAmount,
          });
          setLoading(false);
          // setVoucherDetailsData(res);
          props?.setLoading(false);
          setTotalRecords(res?.result?.totalRecords);
        }
      } else {
        props.setSalesInvoiceList([]);
        props.setLoadSkeleton(false);
        setInvoiceListData([]);
        setTotalRecords(res?.result?.totalRecords);
      }
      setLoading(false);
      props?.setLoading(false);
    } catch (ex: any) {
      setLoading(false);
      props.setSalesInvoiceList([]);
      props.setLoadSkeleton(false);
      setInvoiceListData([]);
    }
  };

  // getVoucherDraftList;

  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    console.log("Filter: ", filter);

    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "AutoNumber",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
  };

  const isDraft = (cliendId: string) => {
    const res = JSON.parse(sessionStorage.getItem(`${cliendId} Sales`) + "");
    if (res) return true;
    else return false;
  };

  // const exportCsv = () => {
  //   VoucherServices.exportCsv(
  //     currentClient?.id,
  //     splitPathInVchType === Voucher_Type.SalesVoucher
  //       ? Voucher_Type.SalesVoucher
  //       : Voucher_Type.PurchaseVoucher,
  //     (page - 1) * pageSize,
  //     pageSize,
  //     filterDate.from,
  //     filterDate.to,
  //     filter.sortCol,
  //     filter.sortDir,
  //     undefined,
  //     undefined,
  //     searchCustomer,
  //     invoiceStatus
  //   )
  //     .then((res) => {
  //       if (res) {
  //         console.log("download sucess", res);
  //       }
  //     })
  //     .catch((ex: any) => {
  //       openNotification("error", ex.message);
  //     });
  // };

  // const downloadAndView = async (
  //   cliendId: string,
  //   voucherId: string,
  //   type: ViewType
  //   // invId: any
  // ) => {
  //   if (cliendId && voucherId) {
  //     setLoadingButtons((prev: any) => ({ ...prev, [voucherId]: true }));
  //     await DownloadService.downloadPdf(cliendId, voucherId, type)
  //       .then((res) => {
  //         console.log("res", res);
  //         if (res) {
  //           console.log("download sucess");
  //           setLoadingButtons((prev: any) => ({ ...prev, [voucherId]: false }));
  //         }
  //       })
  //       .catch((ex) => {
  //         openNotification("error", ex.message);
  //       });
  //   } else {
  //     openNotification("error", "Invalid details.");
  //     setLoadingButtons(false);
  //   }
  // };

  const sendEmail = async (
    cliendId: string,
    voucherId: string,
    type: ViewType = ViewType.Pdf,
    partyId: string
  ) => {
    if (cliendId && voucherId && partyId) {
      await DownloadService.sendPdfEmail(cliendId, voucherId, type, partyId)
        .then((res) => {
          if (res.result) {
            openNotification("success", "Email sent successfully.");
          } else {
            openNotification("error", res?.message);
          }
          setEmailLoading(false);
        })
        .catch((err) => {
          //  setEmailLoading(false);
          openNotification("error", err?.message);
        });
    } else {
      openNotification("error", "Invalid details.");
    }
    setEmailLoading(false);
  };

  let path =
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? "Invoice List"
      : "Bill List";
  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => {
      if (col === "Invoice Amount") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.invAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalInvoiceAmount
              )
        }`;
      } else if (col === "Credit Note") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.refundAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalRefundAmount
              )
        }`;
      } else if (col === "Received") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.receivedAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalReceivedAmount
              )
        }`;
      } else if (col === "Due Amount") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.dueBalance || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(props?.salesInvoiceList?.totalDueAmount)
        }`;
      } else if (col === "Invoice Number") {
        return "Total";
      } else if (col === "Bill No.") {
        return "Total";
      } else if (col === "Bill Amount") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.invAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalInvoiceAmount
              )
        }`;
      } else if (col === "Debit Note") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.refundAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalRefundAmount
              )
        }`;
      } else if (col === "Paid") {
        return `${
          selectedRowKeys.length > 0
            ? Utils.getFormattedNumber(
                selectedRows.reduce(
                  (acc, data) => acc + (data?.receivedAmount || 0),
                  0
                )
              )
            : Utils.getFormattedNumber(
                props?.salesInvoiceList?.totalReceivedAmount
              )
        }`;
      } else {
        return "";
      }
    });
  };

  const columnsA = [
    "S.No.",
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? "Invoice Number"
      : "Bill No.",
    "Party Name",
    "Date",
    "Due Date",
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? "Invoice Amount"
      : "Bill Amount",
    splitPathInVchType === Voucher_Type.SalesVoucher
      ? "Credit Note"
      : "Debit Note",
    splitPathInVchType === Voucher_Type.SalesVoucher ? "Received" : "Paid",
    "Due Amount",
    "Status",
  ];

  const fieldMapping = {
    "S.No.": (item: any) => item?.key + 1,
    "Invoice Number": (item: any) => item?.invNumber?.name,
    "Bill No.": (item: any) => item?.invNumber?.name,
    "Party Name": (item: any) => item?.customerName?.name,
    Date: (item: any) => item?.date,
    "Due Date": (item: any) => dayjs(item?.dueDate).format("DD/MM/YYYY"),
    "Invoice Amount": (item: any) => Utils.getFormattedNumber(item?.invAmount),
    "Bill Amount": (item: any) => Utils.getFormattedNumber(item?.invAmount),
    "Credit Note": (item: any) => Utils.getFormattedNumber(item?.refundAmount),
    "Debit Note": (item: any) => Utils.getFormattedNumber(item?.refundAmount),
    Received: (item: any) => Utils.getFormattedNumber(item?.receivedAmount),
    Paid: (item: any) => Utils.getFormattedNumber(item?.receivedAmount),
    "Due Amount": (item: any) => Utils.getFormattedNumber(item?.dueBalance),
    Status: (item: any) =>
      item?.status === "Paid" ? "Received" : item?.status,
  };

  const exportCsv = (invExportData: InvoiceDataType[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportData;
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      filterDate,
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (invExportData: InvoiceDataType[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportData;

    InvoiceExportService.generatePDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path
    );
    setExportType(0);
  };

  const exportExcel = async (invExportData: InvoiceDataType[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportData;
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportInvoiceData.length > 0) {
              exportCsv(exportInvoiceData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportInvoiceData.length > 0) {
              exportPDF(exportInvoiceData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportInvoiceData.length > 0) {
              exportExcel(exportInvoiceData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  const getQuarterPreset: any = (startMonth: number) => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() + startMonth).startOf("month"),
      fromDate.month(fromDate.month() + startMonth + 2).endOf("month"),
    ];
  };
  const thisYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month()).startOf("month"),
      fromDate.month(fromDate.month() + 11).endOf("month"),
    ];
  };
  const lastYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() - 12).startOf("month"),
      fromDate.month(fromDate.month() - 1).endOf("month"),
    ];
  };
  const getLast15Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(15, "day").startOf("day"); // Start 15 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };
  const getLast7Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(7, "day").startOf("day"); // Start 7 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };

  const getThisMonth = () => {
    const now = dayjs();
    return [now.startOf("month"), now.endOf("month")];
  };
  const getLastMonth = () => {
    const now = dayjs();
    const lastMonth = now.subtract(1, "month");
    return [lastMonth.startOf("month"), lastMonth.endOf("month")];
  };

  return (
    <div>
      <Row
        justify={width <= 768 ? "space-evenly" : "space-between"}
        gutter={windowWidth <= 1024 ? 65 : 0}
        // style={{ marginTop: 10, padding: "10px 18px 3px 18px" }}
      >
        {permissionAdd && (
          <Col xl={6} lg={4}>
            <Space size={5}>
              {/* <Tooltip
              title={
                splitPathInVchType === Voucher_Type.SalesVoucher ? (
                  <>
                    Add Invoice
                    <br />
                    <Tag>
                      <kbd>Shift + F5</kbd>
                    </Tag>
                  </>
                ) : (
                  <>
                    Add Purchase Bill
                    <br />
                    <Tag>
                      <kbd>Shift + F9</kbd>
                    </Tag>
                  </>
                )
              }
            > */}
              <Button
                className="customButtonCss"
                type="primary"
                id="gfg"
                icon={<PlusOutlined />}
                onClick={() => {
                  splitPathInVchType === Voucher_Type.SalesVoucher
                    ? navigate(
                        `/billing/clients/${currentClient?.id}/sales/addInvoice`
                      )
                    : navigate(
                        `/billing/clients/${currentClient?.id}/purchase/addPurchaseBill`
                      );
                }}
              >
                {splitPathInVchType === Voucher_Type.SalesVoucher
                  ? "Invoice"
                  : "Bill"}
              </Button>
              {/* </Tooltip> */}

              {invoiceListData?.length === 0 ? (
                <>
                  <Button type="default" icon={<DownloadOutlined />} disabled>
                    Export
                  </Button>
                </>
              ) : (
                <>
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    <Button type="default" icon={<DownloadOutlined />}>
                      Export
                    </Button>
                  </Popover>
                </>
              )}
              {/* <Badge
              dot={isDraft(`${currentClient?.id}`) ?? false}
              style={{ marginTop: "6px" }}
            >
              <MdOutlineDrafts
                size={22}
                className="cursor"
                style={{
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  color: isDraft(`${currentClient?.id}`)
                    ? "#5d616c"
                    : "lightgray",
                }}
                onClick={() => {
                  if (isDraft(`${currentClient?.id}`)) {
                    navigate(
                      `/accounts/clients/${currentClient?.id}/sales/addInvoice`,
                      {
                        state: {
                          isOpenDraft: true,
                        },
                      }
                    );
                  }
                }}
              />
            </Badge> */}
              {/* <p
              style={{
                color: isDraft(`${currentClient?.id}`) ? "" : "lightgray",
              }}
            >
              {isDraft(`${currentClient?.id}`) ? `New Draft` : `Drafts`}
            </p> */}
            </Space>
          </Col>
        )}
        <Col
          xl={18}
          lg={20}
          style={{ marginTop: width <= 768 ? "6px" : "0px" }}
        >
          <Row justify="end" gutter={[8, width <= 425 ? 10 : 0]}>
            <Col>
              <Input
                style={{
                  width:
                    width <= 464 ? "210px" : width === 375 ? "280px" : "200px",
                  border: "1px solid #f1f3ff",
                }}
                placeholder="Search party"
                allowClear
                onChange={(e: any) => {
                  setLoading(true);
                  setExportInvoiceData([]);
                  setExportType(-1);
                  if (!e.cancelable) {
                    const searchItem = setTimeout(() => {
                      setPage(1);
                      setSearchCustomer(e.target.value);
                    }, 500);
                    return () => clearTimeout(searchItem);
                  } else {
                    setSearchCustomer(e.target.value);
                  }
                }}
                suffix={
                  loading || searchCustomer ? (
                    ""
                  ) : (
                    <img alt="search" src={search} />
                  )
                }
              />
            </Col>
            <Col>
              {/* <CbRangePicker
                companySettingFromDate={companySettings?.period?.from!}
                allowClear={false}
                format="DD/MM/YYYY"
                defaultValue={[
                  dayjs(filterDate?.from, "DD/MM/YYYY"),
                  dayjs(filterDate?.to, "DD/MM/YYYY"),
                ]}
                style={{
                  width:
                    width <= 464 ? "210px" : width === 375 ? "200px" : "250px",
                  border: "1px solid #f1f3ff",
                }}
                onChange={(e: any) => {
                  if (e === null) {
                    setFilterDate({});
                  } else {
                    setFilterDate({
                      ...filterDate,
                      from: dayjs(e[0]).format("DD/MM/YYYY"),
                      to: dayjs(e[1]).format("DD/MM/YYYY"),
                    });
                    localStorage.setItem(
                      "LockPeriod",
                      JSON.stringify({
                        ...filterDate,
                        from: dayjs(e[0]).format("DD/MM/YYYY"),
                        to: dayjs(e[1]).format("DD/MM/YYYY"),
                      })
                    );
                    openNotification("success", `Period locked.`);
                  }
                }}
              /> */}
              <RangePicker
                allowClear={false}
                format="DD/MM/YYYY"
                defaultValue={[
                  dayjs(filterDate?.from, "DD/MM/YYYY"),
                  dayjs(filterDate?.to, "DD/MM/YYYY"),
                ]}
                style={{
                  width:
                    width <= 464 ? "210px" : width === 375 ? "200px" : "250px",
                  border: "1px solid #f1f3ff",
                }}
                onChange={(e: any) => {
                  if (e === null) {
                    setFilterDate({});
                  } else {
                    setFilterDate({
                      ...filterDate,
                      from: dayjs(e[0]).format("DD/MM/YYYY"),
                      to: dayjs(e[1]).format("DD/MM/YYYY"),
                    });
                    localStorage.setItem(
                      "LockPeriod",
                      JSON.stringify({
                        ...filterDate,
                        from: dayjs(e[0]).format("DD/MM/YYYY"),
                        to: dayjs(e[1]).format("DD/MM/YYYY"),
                      })
                    );
                    openNotification("success", `Period locked.`);
                  }
                }}
                presets={[
                  {
                    label: "Today",
                    value: [dayjs().add(0, "d"), dayjs()],
                  },
                  {
                    label: "Last 7 Days",
                    value: getLast7Days(),
                  },
                  {
                    label: "Last 15 Days",
                    value: getLast15Days(),
                  },
                  {
                    label: "This Month",
                    value: getThisMonth(),
                  },
                  {
                    label: "Last Month",
                    value: getLastMonth(),
                  },
                  {
                    label: "Quarter 1",
                    value: getQuarterPreset(0),
                  },
                  {
                    label: "Quarter 2",
                    value: getQuarterPreset(3),
                  },
                  {
                    label: "Quarter 3",
                    value: getQuarterPreset(6),
                  },
                  {
                    label: "Quarter 4",
                    value: getQuarterPreset(9),
                  },
                  {
                    label: "This Year",
                    value: thisYear(),
                  },
                  {
                    label: "Last Year",
                    value: lastYear(),
                  },
                ]}
              />
            </Col>

            <Col>
              <Select
                value={rcmAndCashFilter.rcm}
                style={{
                  width: width === 1024 ? 80 : 160,
                }}
                options={RCMFilterOptions}
                onSelect={(val) => {
                  // if (val === VoucherFilterStatus.Draft) {
                  //   setExportType(-1);
                  //   setInvoiceStatus(val);
                  // } else {
                  setPage(1);
                  setRCMAndCashFilter({
                    ...rcmAndCashFilter,
                    rcm: val,
                  });
                  setExportInvoiceData([]);
                  setExportType(-1);
                  // }
                }}
              />
            </Col>

            <Col>
              <Select
                value={rcmAndCashFilter.cashCredit}
                style={{
                  width: width === 1024 ? 80 : 150,
                }}
                options={CashCreditFilterOptions}
                onSelect={(val) => {
                  // if (val === VoucherFilterStatus.Draft) {
                  //   setExportType(-1);
                  //   setInvoiceStatus(val);
                  // } else {
                  setPage(1);
                  setRCMAndCashFilter({
                    ...rcmAndCashFilter,
                    cashCredit: val,
                  });
                  setExportInvoiceData([]);
                  setExportType(-1);
                  // }
                }}
              />
            </Col>

            <Col>
              <Select
                value={invoiceStatus}
                style={{
                  width: width === 1024 ? 80 : 120,
                }}
                options={[
                  { value: VoucherFilterStatus.All, label: "All", title: "" },
                  {
                    value: VoucherFilterStatus.Active,
                    label: "Active",
                    title: "",
                  },
                  { value: VoucherFilterStatus.Due, label: "Due", title: "" },
                  {
                    value: VoucherFilterStatus.Overdue,
                    label: "Overdue",
                    title: "",
                  },
                  {
                    value: VoucherFilterStatus.Paid,
                    label:
                      splitPathInVchType === Voucher_Type.SalesVoucher
                        ? "Received"
                        : "Paid",
                    title: "",
                  },
                  // { value: VoucherFilterStatus.Estimate, label: "Estimate" },
                  // { value: VoucherFilterStatus.SalesOrder, label: "Sales Order" },
                  {
                    value: VoucherFilterStatus.Deleted,
                    label: "Deleted",
                    title: "",
                  },
                  {
                    value: VoucherFilterStatus.Draft,
                    label: "Draft",
                    title: "",
                  },
                ]}
                onSelect={(val) => {
                  // if (val === VoucherFilterStatus.Draft) {
                  //   setExportType(-1);
                  //   setInvoiceStatus(val);
                  // } else {
                  setPage(1);
                  setInvoiceStatus(val);
                  setExportInvoiceData([]);
                  setExportType(-1);
                  // }
                }}
              />
            </Col>
            <Col>
              <ButtonComponent />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col lg={24}>
          <Table
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
            loading={false}
            summary={() => {
              return (
                <Table.Summary fixed>
                  <Table.Summary.Row
                    style={{
                      backgroundColor: "#f5f8ff",
                      fontWeight: "bold",
                      color: "#4d4d4d",
                    }}
                  >
                    <Table.Summary.Cell
                      index={1}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell index={2} className="fw600">
                      Page Total
                    </Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={3}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell index={4}>{"   "}</Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={5}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={5}
                      className="fw600"
                      // align="right"
                    >
                      ₹{" "}
                      {Utils.getFormattedNumber(
                        props.salesInvoiceList?.totalInvoiceAmount
                      )}
                    </Table.Summary.Cell>

                    {invoiceStatus !== VoucherFilterStatus.Draft && (
                      <>
                        <Table.Summary.Cell
                          index={6}
                          className="fw600"
                          // align="right"
                        >
                          ₹{" "}
                          {Utils.getFormattedNumber(
                            props.salesInvoiceList?.totalRefundAmount
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell
                          index={7}
                          className="fw600"
                          // align="right"
                        >
                          ₹{" "}
                          {Utils.getFormattedNumber(
                            props.salesInvoiceList?.totalReceivedAmount
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell
                          index={8}
                          className="fw600"
                          // align="right"
                        >
                          ₹{" "}
                          {Utils.getFormattedNumber(
                            props.salesInvoiceList?.totalDueAmount
                          )}
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={9} className="fw600">
                          {"   "}
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell index={10} className="fw600">
                          {"   "}
                        </Table.Summary.Cell> */}
                        {/* <Table.Summary.Cell index={11} className="fw600">
                          {"   "}
                        </Table.Summary.Cell> */}
                        {/* <Table.Summary.Cell index={12} className="fw600">
                          {"   "}
                        </Table.Summary.Cell> */}
                      </>
                    )}
                    <Table.Summary.Cell index={13} className="fw600">
                      {"   "}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            rowSelection={rowSelection}
            columns={
              invoiceStatus === VoucherFilterStatus.Draft
                ? draftColumns
                : columns
            }
            // style={{ width: "100%" }}
            dataSource={
              props?.LoadSkeleton
                ? (Array.from({ length: pageSize }, (_, index) => ({
                    key: `loading-${index}`,
                  })) as InvoiceDataType[])
                : invoiceListData
            }
            onChange={tableSort}
            // style={{ overflowY: "scroll" }}
            //  marginTop: "-22px"
            scroll={
              pageSize > 15
                ? { x: 1000, y: window.innerHeight - 580 }
                : { x: 1000 }
            }
            pagination={{
              total: totalRecords,
              current: page,
              pageSize: pageSize,
              showSizeChanger: true,
              onChange: (page: number, pageSize: number) => {
                setPage(page);
                setPageSize(pageSize);
                setExportType(-1);
                setSelectedRowKeys([]);
              },
              pageSizeOptions: ["10", "15", "25", "50", "100"],
              showTotal: (totalRecords, page) =>
                `${page[0]}-${page[1]} of ${totalRecords} items`,
            }}
          />
        </Col>
      </Row>

      {/* <AddRefno open={open} handleCancel={() => setIsOpen(false)} type={type} /> */}
      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            setDeleteOrRevive({
              ...deleteOrRevive,
              id: invoiceId,
              isRev:
                invoiceStatus === VoucherFilterStatus.Deleted ? true : false,
            });
            // setConfirmation(false);
          }}
          text={
            invoiceStatus === VoucherFilterStatus.Deleted
              ? `Are you sure you want to revive "${deleteOrRevive.number}"?`
              : `Are you sure you want to delete this row "${deleteOrRevive.number}" ?`
          }
        />
      )}
      {deleteDraft.isConfirmation && (
        <ConfirmationModal
          open={true}
          onNo={() => setDeleteDraft({ isConfirmation: false, id: "" })}
          onYes={async () => {
            try {
              const deleteData = await DraftService.deleteDraft(
                currentClient?.id!,
                deleteDraft.id
              );
              if (deleteData.result) {
                openNotification("success", "Draft deleted sucessfully.");

                setRefreshAtDelete(!refreshAtDelete);
                setExportType(-1);
                setExportInvoiceData([]);
                setDeleteDraft({ isConfirmation: false, id: "" });
              }
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setDeleteDraft({ isConfirmation: false, id: "" });
            }
          }}
          text={`Are you sure you want to delete this  Draft ?`}
        />
      )}
      {open === "viewSalesInvoice" && (
        <ViewSalesInvoice
          open={open === "viewSalesInvoice"}
          invVoucharType={splitPathInVchType}
          onCancel={() => setIsOpen("")}
          invoiceId={invoiceId}
        />
      )}
      {open === "viewInvoiceNoAllDetails" && (
        <ViewSalesInvoiceNoDetails
          open={open === "viewInvoiceNoAllDetails"}
          onCancel={() => setIsOpen("")}
          invoiceId={invoiceId}
        />
      )}
      {/* {open === "viewPreview" && (
        <ViewPreviewModel
          open={open === "viewPreview"}
          onCancel={() => setIsOpen("")}
          voucherId={invoiceId}
          partyId={partyId}
        />
      )} */}
      {open === "viewPreview" && (
        <SalesInvoicePDF
          open={open === "viewPreview"}
          onCancel={() => setIsOpen("")}
          voucherId={invoiceId}
          partyId={partyId}
        />
      )}
      {open === "viewPurchaseBill" && (
        <PurchaseBillPDF
          open={open === "viewPurchaseBill"}
          type={type}
          onCancel={() => setIsOpen("")}
          voucherId={invoiceId}
        />
      )}
      {open === "emailSendParty" && (
        <EmailSendParty
          open={true}
          onCancel={() => setIsOpen("")}
          voucherId={invoiceId}
          partyId={partyId}
        />
      )}
      {open === "addJornalBadDebts" && (
        <AddJornalBadDebts
          open={true}
          onCancel={() => setIsOpen("")}
          voucherId={invoiceId}
          partyId={partyId}
          amount={11}
        />
      )}
    </div>
  );
};

export default SalesInvoiceTable;

export const InvoiceStatusShow = ({ dueDate, due, refund, invAmount }: any) => {
  // console.log( dueDate, "this is due dte");
  let col: string = "",
    back = "",
    txt = "",
    status;
  let diff = dayjs().diff(dayjs(dueDate), "day", true);
  // console.log("diff..........", diff);
  let splitPathInVchType: Voucher_Type;
  // let splitPathLedgerByGroupsType: SearchLedgerByGroupsTypes;
  // eslint-disable-next-line no-restricted-globals
  if (location.pathname.split("/")[4] === "sales") {
    splitPathInVchType = Voucher_Type.SalesVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Sales;
  } else {
    splitPathInVchType = Voucher_Type.PurchaseVoucher;
    // splitPathLedgerByGroupsType = SearchLedgerByGroupsTypes.Purchase;
  }
  if (due > 0 && diff < 1) status = 0; // Due
  else if (diff >= 1 && due > 0) status = 1; // OverDue
  else if (due === 0 && refund !== invAmount) status = 2; // Paid
  else if (due === 0 && refund === invAmount) status = 3; // Return
  switch (status) {
    case 0:
      col = "#faad14";
      back = "white";
      txt = "Due";
      break;
    case 1:
      col = "#FF4D4F";
      // back = "#fff2f0";
      back = "white";
      txt = "Overdue";
      break;
    case 2:
      col = "#52c41a";
      back = "white";
      txt =
        splitPathInVchType === Voucher_Type.SalesVoucher ? "Received" : "Paid";
      break;
    case 3:
      col = "geekblue";
      back = "white";
      txt =
        splitPathInVchType === Voucher_Type.SalesVoucher
          ? "Credit Note"
          : "Debit Note";
      break;
    default:
  }
  return (
    <>
      <span
        style={{
          border: "1px solid #E4E8F0",
          fontWeight: 500,
          display: "block",
          textAlign: "center",
          fontSize: "13px",
          borderRadius: 4,
          color: col,
          backgroundColor: back,
        }}
      >
        {txt}
      </span>
    </>
  );
};
